import { render, staticRenderFns } from "./QuestionItem.vue?vue&type=template&id=32d4f646&scoped=true&"
import script from "./QuestionItem.vue?vue&type=script&lang=js&"
export * from "./QuestionItem.vue?vue&type=script&lang=js&"
import style0 from "./QuestionItem.vue?vue&type=style&index=0&id=32d4f646&lang=scss&scoped=true&"
import style1 from "./QuestionItem.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d4f646",
  null
  
)

export default component.exports